export default function getImage(article, index)
{
    return `/product/image/${article}/${index}`;
}

export async function getImagesCount(article)
{
    return await (await fetch("product/image/" + article)).json();
}
